import { render } from "./bbcode";

// eslint-disable-next-line
export const EMAIL_REGEX = /([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*/ig;
// eslint-disable-next-line
export const URL_REGEX = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/ig

export const NEWLINE_REGEX = /[\r\n]+?/g;

export function process(data) {
    let emailMatches;
    while ((emailMatches = EMAIL_REGEX.exec(data)) !== null) {
        let match = emailMatches[0];
        const index = emailMatches.index;

        if (data.substr(index - 7, 7) === 'mailto:' || data.substr(index - 2, 2) === '">') {
            EMAIL_REGEX.lastIndex = index + match.length;
            continue;
        }

        const wrapped = `<a target="_blank" href="mailto:${match}">${match}</a>`;
        const before = data.substring(0, index);
        const after = data.substring(index + match.length, data.length);
        data = before + wrapped + after;
        EMAIL_REGEX.lastIndex = index + wrapped.length;
    }
    EMAIL_REGEX.lastIndex = 0;

    let urlMatches;
    while ((urlMatches = URL_REGEX.exec(data)) !== null) {
        let match = urlMatches[0];
        const index = urlMatches.index;

        const beforeLink = data.substr(index - 5, 5);

        // eslint-disable-next-line
        if (/\[url=?]?/.test(beforeLink) || beforeLink === 'ref=\"' || EMAIL_REGEX.test(match)) {
            URL_REGEX.lastIndex = index + match.length;
            continue;
        }

        if (match.toLowerCase().indexOf('www') === 0) {
            match = `http://${match}`;
        }
        const wrapped = `<a target="_blank" href="${match}"> ${match} </a>`;
        const before = data.substring(0, index);
        const after = data.substring(index + match.length, data.length);
        data = before + wrapped + after;
        URL_REGEX.lastIndex = index + wrapped.length;
    }
    let newLineMatches, startListMatches, endListMatches, suppressNewlineWithin = [];

    const START_LIST = /\[LIST\]/gm;
    const END_LIST = /\[\/LIST\]/gm;

    while((startListMatches = START_LIST.exec(data)) !== null || (endListMatches = END_LIST.exec(data)) !== null) {
        const startIndex = startListMatches?.index || -1;
        const endIndex = endListMatches?.index || -1;

        if (startIndex > -1 && endIndex > -1) {
            suppressNewlineWithin.push({startIndex, endIndex})
        }
        
    }

    const lineBreaks = '<br/>'
    while ((newLineMatches = NEWLINE_REGEX.exec(data)) !== null) {
        const match = newLineMatches[0];
        const index = newLineMatches.index;

        const isBetweenBounds = !!suppressNewlineWithin.filter(({startIndex, endIndex}) => {
            return index >= startIndex && index <= endIndex;
        }).length

        if (isBetweenBounds || data.charAt(index - 1) === ']' || data.charAt(index + 1) === '[') {
            NEWLINE_REGEX.lastIndex = index + match.length;
            continue;
        }

        const before = data.substring(0, index);
        const after = data.substring(index + match.length, data.length);
        data = before + lineBreaks + after;
        NEWLINE_REGEX.lastIndex = index + lineBreaks.length;
    }

    data = data.replace(/(<br\/>){2}/gi, lineBreaks);
    return render(data)
}